import PropTypes from 'prop-types';
import HTMLContainer from "components/ui/HTML/HTMLContainer";

const ParagraphText = ({ title, text }) => {
  return (
    <>
      { title && <h2>{ title }</h2> }
      <HTMLContainer>
        { text }
      </HTMLContainer>
    </>
  )
}

ParagraphText.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string.isRequired,
}

export default ParagraphText;
